import { forwardRef, useState } from 'react';
// redux
import { SeccionEjercicioState } from '../../../../store/slices/seccion-ejercicio';
// LaTeX
import Latex from 'react-latex-next';
// mui components
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
// mui icons
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CalculateIcon from '@mui/icons-material/Calculate';
// componentes propios
import Formulario from './Formularios';
import { diapositivaSlice } from '../../../../store/slices/seccion-diapositiva/seccionDiapositivaSlice';

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
}
);

type Props = {
    ejercicio: SeccionEjercicioState
    activo: boolean | undefined
}

const ModalSeccionEjercicio = ({ ejercicio, activo }: Props) => {

    const { eid, tipo, enunciado, respuesta, estado, alternativas } = ejercicio;

    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <IconButton
                onClick={() => setOpen(true)}
                color="inherit"
                size="small"
                disabled={!activo}
            >
                <CalculateIcon fontSize="inherit" sx={activo ? { color: '#3b5998' } : { color: 'grey' }} />
            </IconButton>
            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
                sx={{ fontSize: 18 }}
            >
                <div className='card' key={eid} style={{ minHeight: '100vh', border: 'solid 0px'}}>
                    <div className="card-header">
                        {estado === true && <i className="fa-regular fa-circle-check" style={{ color: 'green' }} />}
                        {estado === false && <i className="fa-regular fa-circle-xmark" aria-hidden="true" style={{ color: 'red' }} />}
                        {estado === undefined && <i className="fa-regular fa-circle" />}
                        <span style={{ fontSize: '1.1em', marginLeft: '7px' }}>Ejercicio</span>

                        <IconButton
                            className='float-end'
                            onClick={() => setOpen(false)}
                            color="inherit"
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                    
                    <div className="card-body">
                        <Latex>{enunciado}</Latex>
                    </div>

                    <Formulario
                        eid={eid}
                        tipo={tipo}
                        estado={estado}
                        respuesta={respuesta}
                        alternativas={alternativas}
                    />
                </div>
            </Dialog>
        </div>
    )
}

export default ModalSeccionEjercicio;